export const TYPE_OF_SETTINGS_SETTINGS = 'settings';
export const TYPE_OF_SETTINGS_RECIPIENTS = 'recipients';
